import { checkSpecialDestination } from "./postalCodeUtils";

const preRegistrationRoles = [
  // "CFRIO",
  "CFRIO-PAQ_FRIO",
  "CFRIO-PAQ_FARMA",
  "CFRIO-PAQ_ACTIVO",
  "CFRIO-PROXIMIDAD",
  "CFRIO-PK_COLDCHAIN",
  // "CFRIO-DEST_ESPECIAL",
];

export const productProfileCorrespondences = {
  "Paq Frío": "CFRIO-PAQ_FRIO",
  "Paq Farma": "CFRIO-PAQ_FARMA",
  "Paq Premium (Coldchain)": "CFRIO-PK_COLDCHAIN",
};

export const handleRoleNotAllowedRedirection = (userProfiles) => {
  let hasPrerregistrationRole = false;

  if (!userProfiles || userProfiles?.data.length == 0) {
    console.error("No se han encontrado perfiles de usuario.");
    return hasPrerregistrationRole;
  }

  userProfiles.data.forEach((profile) => {
    if (preRegistrationRoles.includes(profile.profileCod)) {
      hasPrerregistrationRole = true;
    }
  });

  return hasPrerregistrationRole;
};

// export const checkContractInfoCanDoSpecialDestination = (
//   formValues,
//   reduxProfiles
// ) => {
//   const { data: profiles } = reduxProfiles;
//   const { contractNumber, clientNumber, labellerCode } = formValues;
//   let contractInfoCanDoSpecialDestination = false;

//   if (!reduxProfiles || !formValues) {
//     return false;
//   }

//   if (reduxProfiles?.data?.length === 0) {
//     return false;
//   }

//   for (let profile of profiles) {
//     if (
//       contractNumber === profile?.contractNumber &&
//       clientNumber === profile?.clientNumber &&
//       labellerCode === profile?.labellerCode &&
//       profile?.profileCod.includes("DEST_ESPECIAL")
//     ) {
//       contractInfoCanDoSpecialDestination = true;
//     }
//   }

//   return contractInfoCanDoSpecialDestination;
// };

// export const canContractInfoCanDoRecipientDestination = (
//   formValues,
//   reduxProfiles,
//   participantsDetails
// ) => {
//   if (
//     !formValues ||
//     !reduxProfiles ||
//     !participantsDetails?.recipientPostalCode
//   ) {
//     return true;
//   }
//   const contractInfoCanDoSpecialDestination =
//     checkContractInfoCanDoSpecialDestination(formValues, reduxProfiles);
//   const chosenRecipientHasSpecialDestination = checkSpecialDestination(
//     participantsDetails?.recipientPostalCode
//   );

//   if (
//     contractInfoCanDoSpecialDestination &&
//     chosenRecipientHasSpecialDestination
//   ) {
//     return true;
//   }
//   return false;
// };

export const checkSpecialRole = (userProfiles) => {
  let hasSpecialRole = false;
  for (let profile of userProfiles) {
    if (profile?.profileCod === "CFRIO-DEST_ESPECIAL") {
      hasSpecialRole = true;
    }
  }
  return hasSpecialRole;
};

export const checkProximityRole = (userProfiles) => {
  let hasProximityRole = false;
  for (let profile of userProfiles) {
    if (profile?.profileCod === "CFRIO-PROXIMIDAD") {
      hasProximityRole = true;
    }
  }
  return hasProximityRole;
};

export const checkSpecialRoleInContractBlock = (contracts, userProfiles) => {
  let hasSpecialRole = userProfiles.some(
    (profile) =>
      profile.contractNumber === contracts.contractNumber &&
      profile.clientNumber === contracts.clientNumber &&
      profile.labellerCode === contracts.labellerCode &&
      profile.profileCod === "CFRIO-DEST_ESPECIAL"
  );

  return hasSpecialRole;
};

export const canUseSpecialPostCode = (
  getFieldsValue,
  userProfiles,
  participantType
) => {
  const { contractNumber, clientNumber, labellerCode } = getFieldsValue();
  // const { contractNumber, clientNumber, labellerCode } = currentContractDetails;

  if (!contractNumber || !clientNumber || !labellerCode) {
    return false;
  }

  if (participantType === "sender") {
    return false;
  }

  for (let profile of userProfiles) {
    if (
      profile?.contractNumber === contractNumber &&
      profile?.clientNumber === clientNumber &&
      profile?.labellerCode === labellerCode &&
      profile?.profileCod.includes("DEST_ESPECIAL")
    ) {
      return true;
    }
  }
  return false;
};
